/** Iconos de trazo propios (24×24). Uso: icon('flame'). */
import { s } from '../lib/dom';

const PATHS: Record<string, string[]> = {
  home: ['M3 11l9-7 9 7', 'M5 10v10h14V10', 'M10 20v-6h4v6'],
  book: ['M4 5a2 2 0 0 1 2-2h13v16H6a2 2 0 0 0-2 2z', 'M4 19V5', 'M8 7h7'],
  target: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z', 'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10z', 'M12 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2z'],
  bolt: ['M13 2L4 14h7l-1 8 9-12h-7z'],
  gamepad: ['M6 8h12a4 4 0 0 1 4 4v1a4 4 0 0 1-7 2.6L14 15h-4l-1 .6A4 4 0 0 1 2 13v-1a4 4 0 0 1 4-4z', 'M7 11v3', 'M5.5 12.5h3', 'M16 12h.01', 'M18 13.5h.01'],
  trophy: ['M8 4h8v5a4 4 0 0 1-8 0z', 'M8 6H5a3 3 0 0 0 3 4', 'M16 6h3a3 3 0 0 1-3 4', 'M12 13v4', 'M8 20h8', 'M10 17h4'],
  chart: ['M4 20V4', 'M4 20h16', 'M8 16l3-4 3 2 5-7'],
  user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M4 20a8 8 0 0 1 16 0'],
  settings: ['M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z', 'M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z'],
  sun: ['M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M12 2v2', 'M12 20v2', 'M4.9 4.9l1.4 1.4', 'M17.7 17.7l1.4 1.4', 'M2 12h2', 'M20 12h2', 'M4.9 19.1l1.4-1.4', 'M17.7 6.3l1.4-1.4'],
  moon: ['M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  close: ['M6 6l12 12', 'M18 6L6 18'],
  flame: ['M12 22a7 7 0 0 0 7-7c0-4-3-6-4-9-1 2-2 3-4 3 0-2 0-4-2-6-1 4-4 7-4 12a7 7 0 0 0 7 7z'],
  star: ['M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z'],
  lock: ['M6 11h12v9H6z', 'M8 11V8a4 4 0 0 1 8 0v3'],
  check: ['M5 12l5 5 9-10'],
  play: ['M7 4l13 8-13 8z'],
  pause: ['M7 4h3v16H7z', 'M14 4h3v16h-3z'],
  restart: ['M4 4v6h6', 'M4.5 15a8 8 0 1 0 2-8.5L4 10'],
  flag: ['M5 21V4', 'M5 4h12l-2 4 2 4H5'],
  crown: ['M3 8l4 4 5-7 5 7 4-4-2 11H5z'],
  keyboard: ['M3 6h18v12H3z', 'M7 10h.01', 'M11 10h.01', 'M15 10h.01', 'M7 14h10'],
  clock: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z', 'M12 7v5l3 2'],
  medal: ['M8 3l4 6 4-6', 'M12 21a6 6 0 1 0 0-12 6 6 0 0 0 0 12z', 'M12 13v4'],
  ship: ['M12 3l3 7v6l-3 2-3-2v-6z', 'M9 13l-4 3v3l4-2', 'M15 13l4 3v3l-4-2'],
  car: ['M4.5 16H3v-3l2.5-5h10l3.5 5h1v3h-1.5', 'M9.5 16h5', 'M7 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4z', 'M17 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4z', 'M5.5 12h13'],
  kite: ['M12 2l7 7-7 9-7-9z', 'M12 2v16', 'M5 9h14', 'M12 18c-1.5 1.5 1.5 2.5 0 4'],
  icecream: ['M7 10.5a5 5 0 0 1 10 0', 'M6 10.5h12', 'M7.5 10.5L12 21l4.5-10.5', 'M9.6 15h4.8'],
  heart: ['M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z'],
  globe: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z', 'M3 12h18', 'M12 3a14 14 0 0 1 0 18', 'M12 3a14 14 0 0 0 0 18'],
  shield: ['M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z'],
  award: ['M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12z', 'M8.5 14L7 22l5-3 5 3-1.5-8'],
  logout: ['M9 21H5V3h4', 'M16 17l5-5-5-5', 'M21 12H9'],
  plus: ['M12 5v14', 'M5 12h14'],
  trash: ['M4 7h16', 'M9 7V4h6v3', 'M6 7l1 13h10l1-13'],
  edit: ['M4 20h4L19 9l-4-4L4 16z', 'M13 7l4 4'],
  search: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z', 'M20 20l-4-4'],
  gauge: ['M4 18a8 8 0 1 1 16 0', 'M12 18l4-6'],
  rocket: ['M12 15l-3-3c1-5 4-8 9-9-1 5-4 8-9 9z', 'M9 12l-4 1 2-4 4-1', 'M12 15l-1 4 4-2 1-4', 'M7 17l-2 2'],
  stack: ['M12 3l9 5-9 5-9-5z', 'M3 13l9 5 9-5'],
  graduation: ['M2 9l10-5 10 5-10 5z', 'M6 11v5c3 2 9 2 12 0v-5'],
  arrowRight: ['M5 12h14', 'M13 6l6 6-6 6'],
  arrowLeft: ['M19 12H5', 'M11 6l-6 6 6 6'],
  users: ['M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M2 20a7 7 0 0 1 14 0', 'M16 3.5a4 4 0 0 1 0 7.5', 'M18 14a6 6 0 0 1 4 6'],
  sparkle: ['M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z'],
  copy: ['M8 8h12v12H8z', 'M4 16V4h12'],
  external: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v6H4V6h6'],
};

export function icon(name: keyof typeof PATHS | string, size = 20, label?: string): SVGSVGElement {
  const svg = s(
    'svg',
    {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 1.8,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      class: 'icon',
      'aria-hidden': label ? undefined : 'true',
      role: label ? 'img' : undefined,
      'aria-label': label,
    },
    ...(PATHS[name] ?? PATHS.sparkle!).map((d) => s('path', { d })),
  );
  return svg;
}

export function logo(size = 32): SVGSVGElement {
  return s(
    'svg',
    { viewBox: '0 0 64 64', width: size, height: size, class: 'logo-mark', 'aria-hidden': 'true' },
    s('rect', { x: 4, y: 8, width: 56, height: 48, rx: 12, class: 'logo-base' }),
    s('rect', { x: 4, y: 8, width: 56, height: 42, rx: 12, class: 'logo-cap' }),
    s('path', { d: 'M17 39V21l9 11 9-11v18', fill: 'none', class: 'logo-m', 'stroke-width': 5, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }),
    s('rect', { x: 42, y: 20, width: 5, height: 20, rx: 2.5, class: 'logo-caret' }),
  );
}
